const LAYER_HIDEVR = 5;

export { LAYER_HIDEVR };
